import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { useParams } from 'react-router-dom';

const BehavioralAssessmentPage = () => {
    const { jobId } = useParams();
    const [questions, setQuestions] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    useEffect(() => {
        const fetchQuestions = async () => {
            try {
                console.log(`📌 Fetching Behavioral Assessment for Job ID: ${jobId}`);
                const response = await axios.post('http://127.0.0.1:5000/generate_assessment', {
                    job_id: jobId,
                    assessment_type: 'behavioral'
                });

                if (!response.data.assessment_questions || response.data.assessment_questions.length === 0) {
                    throw new Error("No assessment questions received.");
                }

                let rawQuestions = response.data.assessment_questions;

                // ✅ Ensure correct JSON parsing if needed
                if (typeof rawQuestions === "string") {
                    try {
                        rawQuestions = JSON.parse(rawQuestions);
                    } catch (error) {
                        console.error("❌ Error parsing JSON response:", error);
                        setError("Failed to process questions.");
                        setLoading(false);
                        return;
                    }
                }

                // ✅ Extract only valid questions, remove artifacts, and format correctly
                const formattedQuestions = rawQuestions
                    .map(q => typeof q === "object" && q.question ? q.question : q) // Extract "question" key if present
                    .filter(q => typeof q === "string" && q.trim().length > 0) // Remove empty values
                    .slice(0, 30) // ✅ Ensure exactly 30 questions
                    .map((q, index) => `${index + 1}. ${q.trim()}`); // ✅ Number properly

                setQuestions(formattedQuestions);
            } catch (error) {
                console.error("❌ Error fetching behavioral assessment questions:", error);
                setError("Failed to load assessment questions.");
            } finally {
                setLoading(false);
            }
        };

        fetchQuestions();
    }, [jobId]);

    return (
        <div style={{ padding: '20px', maxWidth: '800px', margin: 'auto' }}>
            <h2>Behavioral Assessment</h2>
            {error && <p style={{ color: "red" }}>{error}</p>}

            {loading ? (
                <p>Loading questions...</p>
            ) : (
                <ol>
                    {questions.length > 0 ? (
                        questions.map((question, index) => (
                            <li key={index} style={{ marginBottom: '10px' }}>{question}</li>
                        ))
                    ) : (
                        <p>No questions available.</p>
                    )}
                </ol>
            )}
        </div>
    );
};

export default BehavioralAssessmentPage;

